import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router';
import { resubmitApp, header } from './CommonMessages';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';
import { pathname } from '../../../../utils';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogAction: { alignSelf: 'center' },
  button: {
    marginTop: theme.spacing(2),
    minWidth: 175,
  },
}));

export default function LowMargin({ loading, closeDialog, storeName }) {
  const classes = useStyles();
  const history = useHistory();

  const headerReason = (
    <Typography gutterBottom>
      <b>{header}</b>
    </Typography>
  );

  const content = (
    <>
      <Typography>
        Our team has reviewed the submitted Lines and has decided not to offer{' '}
        {storeName} a Growth Plan at this time.
      </Typography>
      <Typography>
        We have returned your Lines to ‘Draft’ to give you an opportunity to
        edit the information you provided.
      </Typography>
      <Typography>{resubmitApp}</Typography>
    </>
  );

  const actions = (
    <LoadingButton
      className={classes.button}
      loading={loading}
      onClick={() => history.push(pathname.lines.url)}
    >
      <b>Go to Lines</b>
    </LoadingButton>
  );

  return (
    <>
      <DialogContent className={classes.root}>
        <>
          {headerReason}
          {content}
        </>
      </DialogContent>{' '}
      <DialogActions className={classes.dialogAction}>{actions}</DialogActions>
    </>
  );
}
